import { createBrowserRouter } from 'react-router'

import Home from './pages/Home/Home'
import Layout from './components/Layout/Layout'
import Notfound from './pages/Notfound/Notfound'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
])

export default router
